import config from 'config';

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function calcReturnByDate(tld, membershipLevelGroup, dateShipped) {
  const returnByDays = config.get('public.brand.returnByDays');
  const returnByDaysByMembership = returnByDays[`${tld}`]
    ? returnByDays[`${tld}`]
    : returnByDays.default;
  const returnByDateCount =
    membershipLevelGroup === 'vip'
      ? returnByDaysByMembership.vip
      : returnByDaysByMembership.lead;
  const lastDate = new Date(dateShipped);
  lastDate.setDate(lastDate.getDate() + returnByDateCount);
  return lastDate;
}

export function stringifiedReturnByDate(
  tld,
  membershipLevelGroup,
  dateShipped
) {
  const ldate = calcReturnByDate(tld, membershipLevelGroup, dateShipped);
  return `${
    MONTH_NAMES[ldate.getMonth()]
  } ${ldate.getDate()}, ${ldate.getFullYear()}`;
}

export function findKeyInNestedStructure(data, targetKey) {
  function traverse(obj) {
    if (Array.isArray(obj)) {
      for (let i = 0; i < obj.length; i++) {
        const result = traverse(obj[i]);
        if (result) {
          return result;
        }
      }
    }

    if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (key === targetKey) {
          return obj[key];
        }
        const result = traverse(obj[key]);
        if (result) {
          return result;
        }
      }
    }

    return null;
  }

  return traverse(data);
}
